import { render, staticRenderFns } from "./password-reset-modal.vue?vue&type=template&id=48e79c0c&"
import script from "./password-reset-modal.vue?vue&type=script&lang=js&"
export * from "./password-reset-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports